

import React, { memo } from 'react';

import CollaboratorsList from './CollaboratorsList';








function AddTeamsTab(props) {
  const { teams, onAddMember, membersIds, loading } = props;

  return (
    <CollaboratorsList
      listItems={teams || []}
      type="teams"
      onAddMember={onAddMember}
      membersIds={membersIds}
      loading={loading} />);


}

export default memo(AddTeamsTab);